import Layout from '@/View/Sales/layout/Layout.vue'
export const Sales = {
  // CRM dashboard Start
  path: '/sales',
  component: Layout,
  hidden: false,
  redirect: '/sales/dashboard',
  name: 'Sales',
  meta: {
    breadCrumb: 'Sales',
    title: 'Sales',
    icon: 'dashboard',
    selected: false,
    permission: ''
  },
  children: [{
    path: '/sales/dashboard',
    component: () => import('@/View/Sales/dashboard/dashboard.vue'),
    name: 'SalesDashboard',
    meta: {
      breadCrumb: 'Dashboard',
      icon: 'dashboard',
      title: 'Dashboard',
      selected: false,
      permissionList: []
    }
  },
  {// Sales Inquiry routing
    path: '/Sales/SalesInquiry',
    component: () => import('@/View/Sales/Main/main.vue'),
    hidden: false,
    redirect: '/sales/SalesInquiry/List',
    name: 'SalesInquiryList',
    meta: {
      breadCrumb: 'SalesInquiry',
      title: 'Sales Inquiry',
      icon: 'fas fa-headset',
      color: 'primary',
      selected: false,
      permissionList: []
    },
    children: [{
      path: '/sales/SalesInquiry/List',
      component: () => import('@/View/Sales/SalesInquiry/SalesInquiryList.vue'),
      name: 'SalesInquiryList',
      hidden: false,
      meta: {
        breadCrumb: 'SalesInquiryList',
        title: 'List'
      }
    }]
  },
  {// Setting object start
    path: '/sales/setting',
    component: () => import('@/View/Sales/Main/main.vue'),
    hidden: false,
    redirect: '/sales/setting/dashboard',
    name: 'SalesSettings',
    meta: {
      breadCrumb: 'Setting',
      title: 'Settings',
      icon: 'fa fa-cog',
      selected: false,
      permissionList: []
    },
    children: [{
      path: '/sales/setting/dashboard',
      component: () => import('@/View/Sales/Settings/Dashboard/dashboard.vue'),
      name: 'SalesSettings',
      hidden: false,
      meta: {
        breadCrumb: 'Dashboard',
        title: 'Dashboard'
      }
    },
    {
      path: '/sales/setting/ProductInquiryQuestion',
      component: () => import('@/View/Sales/Settings/ProductInquiryQuestion/ProductQuestionList.vue'),
      name: 'ProductInquiryQuestion',
      hidden: false,
      meta: {
        breadCrumb: 'ProductInquiryQuestion',
        icon: 'fas fa-box',
        color: 'primary',
        title: 'Product Inquiry Question',
        permissionList: ['sales_setting__product_inquiry_question__manage']
      }
    },
    {
      path: '/sales/setting/ProductInquiryQuestionAdd/:questionMasterId',
      component: () => import('@/View/Sales/Settings/ProductInquiryQuestion/addProductQuestion.vue'),
      name: 'addProductQuestion',
      hidden: true,
      meta: {
        breadCrumb: 'addProductQuestion',
        icon: 'SQ',
        color: 'primary',
        title: 'Add New Question',
        permissionList: ['sales_setting__product_inquiry_question__manage']
      }
    },
    {
      path: '/sales/setting/ProductquestionDetail/:questionMasterId',
      component: () => import('@/View/Sales/Settings/ProductInquiryQuestion/ProductquestionDetails.vue'),
      name: 'ProductQuesListDetail',
      hidden: true,
      meta: {
        breadCrumb: 'ProductQuesListDetail',
        icon: 'SQ',
        color: 'primary',
        title: 'Sales Question detail',
        permissionList: ['sales_setting__product_inquiry_question__manage']
      }
    },
    {
      path: '/sales/setting/SalesQuesList',
      component: () => import('@/View/Sales/Settings/SalesInquiryQuestion/SalesQuesList.vue'),
      name: 'SalesInquiryQuestion',
      hidden: false,
      meta: {
        breadCrumb: 'SalesInquiryQuestion',
        icon: 'fas fa-question-circle',
        color: 'primary',
        title: 'Sales Inquiry Question',
        permissionList: ['sales_setting__sales_inquiry_question__manage']
      }
    },
    {
      path: '/sales/setting/SalesInquiryTopic',
      component: () => import('@/View/Sales/Settings/SalesInquiryTopic/salesTopicList.vue'),
      name: 'SalesInquiryTopic',
      hidden: false,
      meta: {
        breadCrumb: 'SalesInquiryTopic',
        icon: 'mdi mdi-head-question',
        color: 'primary',
        title: 'Sales Inquiry Topic',
        permissionList: ['sales_setting__sales_inquiry_topic__manage']
      }
    },
    {
      path: '/sales/setting/SalesInquiryTopicDetail/:salesInquiryTopicID',
      component: () => import('@/View/Sales/Settings/SalesInquiryTopic/SalesInquiryTopicDetail.vue'),
      name: 'SalesInquiryTopicDetail',
      hidden: true,
      meta: {
        breadCrumb: 'SalesInquiryTopicDetail',
        icon: '',
        color: '',
        title: 'Sales Topic Detail',
        permissionList: []
      }
    },
    {
      path: '/sales/setting/SalesInquiryQuestionAdd/:questionMasterId',
      component: () => import('@/View/Sales/Settings/SalesInquiryQuestion/addSalesQuestion.vue'),
      name: 'addSalesQuestion',
      hidden: true,
      meta: {
        breadCrumb: 'addSalesQuestion',
        icon: 'SQ',
        color: 'primary',
        title: 'Add New Question',
        permissionList: ['sales_setting__sales_inquiry_question__manage']
      }
    },
    {
      path: '/sales/setting/SalesQuesListDetail/:questionMasterId',
      component: () => import('@/View/Sales/Settings/SalesInquiryQuestion/questionDetails.vue'),
      name: 'SalesQuesListDetail',
      hidden: true,
      meta: {
        breadCrumb: 'SalesQuesListDetail',
        icon: 'SQ',
        color: 'primary',
        title: 'Sales Question detail',
        permissionList: ['sales_setting__sales_inquiry_question__manage']
      }
    },
    {
      path: '/sales/setting/SalesInquirySource',
      component: () => import('@/View/Sales/Settings/SalesInquirySource/SalesInquirySourceList.vue'),
      name: 'SalesInquirySource',
      hidden: false,
      meta: {
        breadCrumb: 'SalesInquirySource',
        icon: 'fab fa-osi',
        color: 'primary',
        title: 'Sales Inquiry Source',
        permissionList: ['sales_setting__sales_inquiry_source__manage']
      }
    }]
  },
  {
    path: '/sales/setting',
    component: () => import('@/View/Sales/Main/main.vue'),
    hidden: false,
    redirect: '/sales/setting/dashboard',
    name: 'Items',
    meta: {
      breadCrumb: 'Setting',
      title: 'Settings',
      icon: 'fas fa-box',
      selected: false,
      permissionList: []
    },
    children: [
      {
        path: '/sales/setting/ItemList',
        component: () => import('@/View/Sales/Settings/SalesInquiryItem/salesItemList.vue'),
        name: 'salesItemList',
        hidden: false,
        meta: {
          breadCrumb: 'salesItemList',
          icon: 'fas fa-box',
          color: 'primary',
          title: 'Item List',
          permissionList: ['sales_setting__items__view_all']
        }
      },
      {
        path: '/sales/setting/CateogryList',
        component: () => import('@/View/Sales/Settings/SalesInquiryItem/SalesCateogryList.vue'),
        name: 'SalesCateogryList',
        hidden: false,
        meta: {
          breadCrumb: 'SalesCateogryList',
          icon: 'fas fa-box',
          color: 'primary',
          title: 'Cateogry List',
          permissionList: ['sales_setting__item_category__manage']
        }
      },
      {
        path: '/sales/setting/BundleList',
        component: () => import('@/View/Sales/Settings/SalesInquiryItem/SalesBundleList.vue'),
        name: 'SalesBundleList',
        hidden: false,
        meta: {
          breadCrumb: 'SalesBundleList',
          icon: 'fas fa-box',
          color: 'primary',
          title: 'Bundle List',
          permissionList: ['sales_setting__bundle__view_all']
        }
      },
      {
        path: '/sales/setting/Items/Details/:itemDetailId',
        component: () => import('@/View/Sales/Settings/SalesInquiryItem/SalesDetails.vue'),
        name: 'SalesDetails',
        hidden: false,
        meta: {
          breadCrumb: 'SalesDetails',
          icon: '',
          color: '',
          title: 'Detail Items/Bundle',
          permissionList: []
        }
      }
    ]
  }]
}



// WEBPACK FOOTER //
// ./src/View/Sales/router/index.js